/* The Absorption Company: pricing plan selector (absorption-pricing).
   Document-level delegation, so it keeps working when the theme editor re-renders a section. */
(function () {
  if (window.__acLandingBound) return;
  window.__acLandingBound = true;
  document.addEventListener('click', function (e) {
    var plan = e.target.closest('[data-ac-plan]');
    if (!plan || e.target.closest('[data-ac-plan-cta]')) return;
    var group = plan.closest('[data-ac-pricing]');
    if (group) group.querySelectorAll('[data-ac-plan]').forEach(function (p) { p.classList.toggle('is-selected', p === plan); });
  });
})();
